import { filterObjectKeys } from '../utils';

/**
 * @param education
 * @returns {string[]}
 */
export function useAvailableSpecialties(education) {
  return Object.keys(filterObjectKeys(education?.specialtiesAndProcedures, 'specialty'));
}
